var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-progressbar",style:({ background: _vm.backgroundColor })},[_c('div',{staticClass:"bar",class:{ 'has-progress': _vm.value > 0 },style:({ background: _vm.progressColor, width: `${_vm.barWidth}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }